/**
 * Давным-давно, в далёкой-далёкой галактике...
 * Был язык JS. Он не любил цифры, да к тому же из поля ввода чисел всегда конвертировалось в строку...
 * И на одном из этапов threshold в z3k_config стали строковыми значениями...
 * Функция исправляет эту беду.
 */
export function convertThreshold(threshold) {
    if (threshold == null || threshold === '') {
        return null;
    }
    return parseInt(threshold + '', 10);
}
